import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchGiftCards, clearGiftCardsErrors, deleteGiftCard } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  giftcards: PropTypes.object,
  giftcardDisabled: PropTypes.bool,
  onGiftCardDisable: PropTypes.func,
};

class ShowGiftCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.giftcardDelete && (this.state.delete || nextProps.giftcards.delete)) {
      const giftcards = nextProps.giftcards;
      giftcards.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'GiftCard deleted!',
        giftcards,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteGiftCard(this.state.deleteId));
    this.props.dispatch(fetchGiftCards({ page: 1 }));
  }
  handleDisable(giftcard) {
    const data = giftcard;
    data.disabled = !giftcard.disabled;
    this.props.onGiftCardDisable(data);
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearGiftCardsErrors());
    this.props.dispatch(fetchGiftCards({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.giftcards.results.map((giftcard, i) =>
      <TableRow key={i}>
        <TableRowColumn style={{width: '100px'}} key={i}>{giftcard.principal}</TableRowColumn>
        <TableRowColumn key={i}>{giftcard.code}</TableRowColumn>
        <TableRowColumn style={{width: '100px'}} key={i}>{giftcard.balance}</TableRowColumn>
        <TableRowColumn key={i}>{giftcard.recipientName}</TableRowColumn>
        <TableRowColumn key={i}>{giftcard.recipientEmail}</TableRowColumn>
        {/* <TableRowColumn key={i}>{(giftcard.startDate) ? giftcard.datePurchased.split('T')[0] : null}</TableRowColumn> */}
        <TableRowColumn key={i}>
          <ActionButtons
            onEdit={`/giftcards/edit/${giftcard.id}`}
            onView={`/giftcards/view/${giftcard.id}`}
            onDisable={() => this.handleDisable(giftcard)}
            disabled={giftcard.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete GiftCard"
          dialogMessage="Do you really want to delete this giftcard?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn style={{width: '100px'}}>Principal</TableHeaderColumn>
              <TableHeaderColumn>Code</TableHeaderColumn>
              <TableHeaderColumn style={{width: '100px'}}>Balance</TableHeaderColumn>
              <TableHeaderColumn>Recipient Name</TableHeaderColumn>
              <TableHeaderColumn>Recipient Email</TableHeaderColumn>
              {/* <TableHeaderColumn>Date Purchased</TableHeaderColumn> */}
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowGiftCards.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowGiftCards.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.giftCards.error,
    giftcardDelete: state.giftCards.giftcardDelete,
    giftcardDisabled: state.giftCards.giftcardDisabled,
    giftcards: state.giftCards,
  };
}

export default connect(mapStateToProps)(ShowGiftCards);



// WEBPACK FOOTER //
// ./src/components/giftCards/ShowGiftCards.js